import FlexBox from 'components/Shared/Container/FlexBox';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SiteType } from 'types/site.types';
import { convertHexToRGBA } from 'utils/color';
import { StackedArea, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import MobileSiteBatchDetailsSlide from './MobileSiteBatchDetailsSlide';
import { ProductJourneyPages } from '../pages';
import { getBreadcrumb } from 'utils/breadcrumbUtils';
import Header from './Header';
import SiteListItem from './SiteListItem';
export const BackgroundContainer = styled(FlexBox) `
  padding: 16px;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  border-radius: 6px;
  background: ${({ theme }) => theme.palette.grey[10]};
`;
const Container = styled.div `
  padding: 0 16px;
`;
const List = styled.div `
  margin-top: 16px;

  .ReactCollapse--collapse {
    transition: height 250ms;
  }
`;
export const Title = styled.div `
  font-size: 16px !important;
  font-weight: 800 !important;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
export const HeaderTextContainer = styled.div `
  color: ${({ hasMedia, theme }) => hasMedia ? '#000' : theme.palette.grey['A800']};
  width: 100%;
  overflow: hidden !important;
`;
export const Location = styled.div `
  line-height: 1;
  font-weight: 300;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
export const OutputComponent = styled.div `
  display: inline-flex;
  padding: 4px 8px;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadiusButton};
  background: ${convertHexToRGBA('#ffffff', 0.8)};
  color: ${({ theme }) => theme.palette.grey.A800};
  box-shadow: ${({ theme }) => theme.shadows[0]};
  font-weight: 700;
  height: 28px;
  font-size: 14px;
`;
export const ClusterTag = styled(FlexBox) `
  white-space: nowrap;
  overflow: hidden;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-overflow: ellipsis;
`;
export const TotalValue = styled(FlexBox) `
  color: ${({ theme }) => theme.palette.grey.A800};
  font-family: Lato;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
`;
const SiteOverviewSlideContent = ({ itemsRef, activeSiteId, chainStepActivity, isBatchTracingActive, selectedRawMaterial, hasOtherIngredients, isSelectedActivityTraceable, isSelectedStepTraceable, isMobile, onItemClick, }) => {
    const { t } = useTranslation();
    const { activateStackedContent } = useStackableContent();
    const activity = chainStepActivity.activity;
    const items = useMemo(() => {
        var _a, _b, _c;
        if (((_a = activity.site) === null || _a === void 0 ? void 0 : _a.siteType) === SiteType.CLUSTER &&
            ((_c = (_b = activity.site) === null || _b === void 0 ? void 0 : _b.sites) === null || _c === void 0 ? void 0 : _c.edges)) {
            const farmCluster = activity.site;
            return farmCluster.sites.edges.map(({ node }) => node);
        }
        if (activity.site) {
            return [activity.site];
        }
        return [];
    }, [activity.site]);
    const activeSite = useMemo(() => items.find(({ id }) => id === activeSiteId), [activeSiteId, items]);
    const openSiteBatchDetailsSlide = () => {
        activateStackedContent({
            renderComponent: () => (React.createElement(MobileSiteBatchDetailsSlide, { activeStepActivity: chainStepActivity, isSelectedActivityTraceable: isSelectedActivityTraceable, isSelectedStepTraceable: isSelectedStepTraceable, hasOtherIngredients: hasOtherIngredients, selectedRawMaterial: selectedRawMaterial, site: activeSite })),
            id: ProductJourneyPages.SITE_BATCH_TRACING,
            area: StackedArea.PAGE,
            isActive: true,
            layout: {
                hasBackButton: true,
                hasHeader: true,
                hasHeaderScrollEffect: false,
                hasFooter: true,
            },
            breadcrumb: getBreadcrumb(ProductJourneyPages.SITE_BATCH_TRACING, t),
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { activity: activity, isActive: !activeSiteId || isMobile }),
        React.createElement(Container, null,
            React.createElement(List, null, items.map((site) => {
                return (React.createElement(SiteListItem, { key: site.id, site: site, chainStepActivity: chainStepActivity, 
                    // @ts-ignore
                    ref: (el) => (itemsRef.current[id] = el), isBatchTracingActive: isBatchTracingActive, hasOtherIngredients: hasOtherIngredients, rawMaterial: selectedRawMaterial, isSelectedActivityTraceable: isSelectedActivityTraceable, isSelectedStepTraceable: isSelectedStepTraceable, selectedSiteId: activeSiteId, onClick: onItemClick, onOpenSiteBatchDetailsSlide: openSiteBatchDetailsSlide }));
            })))));
};
export default SiteOverviewSlideContent;
